var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { LotteryBrandPriceModel, CurrencyEnum } from '../../../../../models/modules/lotteryplatofrm.models';
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import "../dialogs/manage-currencies-dialog";
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import * as Enumerable from 'linq';
import { LotteryClientService } from '../../../../../services/modules/lottery-client.service';
import { CurrencyClientService } from '../../../../../services/modules/currency-client.service';
import { BindingSignaler } from "aurelia-templating-resources";
import { FormatterHelper } from "../../../../../helpers/numbers-helper";
import { DialogServiceConstants } from "../../../../../constants/basics/dialog.constants";
import { RequestClient } from "../../../../../services/basics/request-client.service";
import { LotteryBrandsOperatorDialog } from "../dialogs/brandlotteryoperator-dialog-host";
var LotteryTickets = /** @class */ (function (_super) {
    __extends(LotteryTickets, _super);
    function LotteryTickets(notificationService, i18N, dialogClientService, lotteryClientService, currencyClientService, signaler, dialogClient, requestClient, brandLotteryOperatorDialog) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.dialogClientService = dialogClientService;
        _this.lotteryClientService = lotteryClientService;
        _this.currencyClientService = currencyClientService;
        _this.signaler = signaler;
        _this.dialogClient = dialogClient;
        _this.requestClient = requestClient;
        _this.brandLotteryOperatorDialog = brandLotteryOperatorDialog;
        _this.jackPotRanges = [];
        _this._promiseCount = 0;
        _this.message = null;
        _this.showTicketPrice = true;
        _this.arePricesBeingCalculated = false;
        return _this;
    }
    LotteryTickets.prototype.getLabel = function (range) {
        return range.lotteryJackpotRangeId ? ('Range: €' + FormatterHelper.getformattedValue(Number(range.rangeFrom), navigator.language, 0) + ' - €' + FormatterHelper.getformattedValue(Number(range.rangeTo), navigator.language, 0)) : 'Any Jackpot Range';
    };
    LotteryTickets.prototype.onShouldUpdateRateChanged = function ($event, item, range) {
        var isChecked = $event.detail.value;
        if (!isChecked)
            return;
        var rate = this.rates.firstOrDefault(function (x) { return x.currencyId == item.currencyId; });
        var defaultPrice = Enumerable.from(this.lotteryPricingModel.lotteryBrandPrices)
            .where(function (x) { return x.lotteryJackpotRangeId == range.lotteryJackpotRangeId; }).firstOrDefault(function (s) { return s.currencyId == CurrencyEnum.Euro; });
        if (!rate)
            return;
        var price = defaultPrice.price;
        this.lotteryClientService.calculatePrice({
            currencyRate: rate.euroRate,
            roundNearest: 2,
            price: price
        }).then(function (calculatedResult) {
            item.price = calculatedResult.calculatedPrice;
        });
    };
    LotteryTickets.prototype.isCurrencyNotEuro = function (currencyId) {
        return currencyId != CurrencyEnum.Euro;
    };
    LotteryTickets.prototype.isCurrencyEuro = function (currencyId) {
        return currencyId == CurrencyEnum.Euro;
    };
    // show delete icon for all currencies except euro
    LotteryTickets.prototype.canDeleteCurrency = function (lotteryJackpotRangeId, currencyId) {
        var findEuroInArray = Enumerable.from(this.lotteryPricingModel.lotteryBrandPrices)
            .where(function (x) { return x.lotteryJackpotRangeId == null && x.currencyId == CurrencyEnum.Euro; }).toArray();
        return ((lotteryJackpotRangeId == null && currencyId != CurrencyEnum.Euro) || (currencyId == CurrencyEnum.Euro && lotteryJackpotRangeId == null && findEuroInArray.length > 1));
    };
    LotteryTickets.prototype.addTicketPrice = function (item) {
        // check for created tiers. User can assign the ticket only if tiers are exists.
        var lotteryJackpotPriceTier = Enumerable.from(this.item.lotteryPriceTiers).firstOrDefault(function (x) { return x.isJackpot; });
        if (lotteryJackpotPriceTier == null) {
            // when lottery doesn't set lottery price trier, this error message will show up, once lottery has lottery price tier and jackpot, we can able to set ticket price
            this.message = this.i18N.tr('alert-message-to-set-lotterypricetier');
            this.showTicketPrice = false;
            return;
        }
        // checking for exist ranges.
        var rangeList = Enumerable.from(lotteryJackpotPriceTier.lotteryJackpotRanges)
            .select(function (x) { return x.lotteryJackpotRangeId; })
            .toArray();
        var currencyModel = {
            currencyId: CurrencyEnum.Euro,
            currencyRates: null
        };
        for (var i = 0; i <= rangeList.length; i++) {
            var doesEuroExistInLotteryBrandPrice = Enumerable.from(this.lotteryPricingModel.lotteryBrandPrices)
                .any(function (x) { return x.lotteryJackpotRangeId == rangeList[i] && x.currencyId == CurrencyEnum.Euro; }); // Currencytype.euro has 1 value, this is from enum
            // If Euro is already selected, free currency dropdown selection to select any currency.
            if (doesEuroExistInLotteryBrandPrice)
                currencyModel = null;
            this.creatingCurrencyModal(rangeList[i], currencyModel);
        }
    };
    LotteryTickets.prototype.creatingCurrencyModal = function (rangeId, currencyModel) {
        var model = new LotteryBrandPriceModel();
        model.currencyId = currencyModel ? currencyModel.currencyId : 0;
        model.lotteryPricingModelId = this.lotteryPricingModel.lotteryPricingModelId;
        model.price = 0; // default set null to showing empty string on 1st time add ticket price
        model.decimalPointRounding = 2;
        model.countryId = null;
        model.lotteryJackpotRangeId = rangeId;
        this.lotteryPricingModel.lotteryBrandPrices.push(model);
        this.signaler.signal("reloadPrices");
    };
    LotteryTickets.prototype.onPriceChanged = function ($event, item, range) {
        var _this = this;
        var willRatesBeUpdated = false;
        if (item && item.currencyId == this.defaultCurrencyId) {
            this.arePricesBeingCalculated = true;
            var value_1 = $event.detail.newValue;
            var count_1 = ++this._promiseCount;
            var initialPriceCalculationCount_1 = 0;
            var completedPriceCalculationCount_1 = 0;
            Enumerable.from(this.lotteryPricingModel.lotteryBrandPrices).where(function (x) { return x.currencyId != _this.defaultCurrencyId
                && x.shouldUpdateCurrencyRate && x.lotteryJackpotRangeId == range.lotteryJackpotRangeId; }).forEach(function (price) {
                var rate = _this.rates == undefined ? false : _this.rates.firstOrDefault(function (x) { return x.currencyId == price.currencyId; });
                initialPriceCalculationCount_1++;
                if (rate) {
                    willRatesBeUpdated = true;
                    _this.lotteryClientService.calculatePrice({
                        currencyRate: rate.euroRate,
                        roundNearest: price.decimalPointRounding,
                        price: Number(value_1)
                    }).then(function (calculatedResult) {
                        if (_this._promiseCount == count_1) {
                            completedPriceCalculationCount_1++;
                            price.price = calculatedResult.calculatedPrice;
                            if (initialPriceCalculationCount_1 == completedPriceCalculationCount_1) {
                                _this.arePricesBeingCalculated = false;
                            }
                        }
                    });
                }
            });
        }
        if (!willRatesBeUpdated) {
            this.arePricesBeingCalculated = false;
        }
    };
    LotteryTickets.prototype.onRoundingChanged = function ($event, item) {
        var _this = this;
        if (item && item.currencyId != this.defaultCurrencyId) {
            var rate = this.rates.firstOrDefault(function (x) { return x.currencyId == item.currencyId; });
            var defaultPriceEntry = Enumerable.from(this.lotteryPricingModel.lotteryBrandPrices).firstOrDefault(function (lbp) { return lbp.currencyId == _this.defaultCurrencyId; });
            var count_2 = ++this._promiseCount;
            this.lotteryClientService.calculatePrice({
                currencyRate: rate.euroRate,
                roundNearest: item.decimalPointRounding,
                price: Number(defaultPriceEntry.price)
            }).then(function (calculatedResult) {
                if (_this._promiseCount == count_2) {
                    item.price = calculatedResult.calculatedPrice;
                }
            });
        }
    };
    Object.defineProperty(LotteryTickets.prototype, "alreadyAddedCurrencyIds", {
        get: function () {
            if (this.lotteryPricingModel && this.lotteryPricingModel.lotteryBrandPrices) {
                return Enumerable.from(this.lotteryPricingModel.lotteryBrandPrices).select(function (x) { return x.currencyId; }).toArray();
            }
            return [];
        },
        enumerable: false,
        configurable: true
    });
    LotteryTickets.prototype.manageCurrencies = function () {
        this.dialogClientService.show("./lottery/dialogs/manage-currencies-dialog", this);
    };
    LotteryTickets.prototype.isReadonly = function (index) {
        if (!this.lotteryPricingModel || !this.item || !this.item.navigationInfo)
            return true;
        if (index > 0) {
            return true;
        }
        else {
            return this.item.navigationInfo.brandId && this.item.navigationInfo.brandId != this.lotteryPricingModel.brandId;
        }
    };
    LotteryTickets.prototype.onActivated = function (item) {
        var _this = this;
        this.currencyClientService.getCurrencies().then(function (x) {
            _this.currencies = x;
            _this.defaultCurrency = Enumerable.from(x).firstOrDefault(function (x) { return x.currencyId == _this.defaultCurrencyId; });
            _this.defaultCurrencyId = CurrencyEnum.Euro; // by default all ticket prices are set as euros. 
        });
        this.currencyClientService.getRates().then(function (rates) {
            _this.rates = Enumerable.from(rates);
        });
        if (!item.lotteryPricingModels)
            item.lotteryPricingModels = [];
        this.lotteryPricingModel = item.lotteryPricingModels[0];
        var jackpotPriceTier = Enumerable.from(item.lotteryPriceTiers).firstOrDefault(function (x) { return x.isJackpot; });
        if (jackpotPriceTier && jackpotPriceTier.lotteryJackpotRanges)
            this.jackPotRanges = Enumerable.from(jackpotPriceTier.lotteryJackpotRanges).toArray();
        //insert a null range for prices to be inserted without a range
        this.jackPotRanges.splice(0, 0, {
            lotteryJackpotRangeId: null,
            lotteryPriceTierId: -1,
            rangeFrom: 0,
            rangeTo: 0
        });
    };
    LotteryTickets.prototype.getPricesForRange = function (range) {
        var prices = this.lotteryPricingModel && this.lotteryPricingModel.lotteryBrandPrices ?
            Enumerable.from(this.lotteryPricingModel.lotteryBrandPrices).where(function (x) { return x.lotteryJackpotRangeId == range.lotteryJackpotRangeId; }).toArray()
            : [];
        // order by currency name only if currency name exists
        var allprices = Enumerable.from(prices).where(function (x) { return x.currency != null; }).orderBy(function (x) { return x.currency.name; }).toArray()
            .concat(Enumerable.from(prices).where(function (x) { return x.currency == null; }).toArray());
        return allprices;
    };
    Object.defineProperty(LotteryTickets.prototype, "masterTicket", {
        get: function () {
            var _this = this;
            if (this.lotteryPricingModel && this.lotteryPricingModel.lotteryBrandPrices && this.jackPotRanges) {
                var range = Enumerable.from(this.jackPotRanges).firstOrDefault(function (x) { return !x.rangeFrom && !x.rangeTo; });
                if (range) {
                    var master = Enumerable.from(this.lotteryPricingModel.lotteryBrandPrices).firstOrDefault(function (x) { return x.lotteryJackpotRangeId == range.lotteryJackpotRangeId && x.currencyId == _this.defaultCurrencyId; });
                    return master;
                }
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    LotteryTickets.prototype.removePrice = function (item, indexPlace) {
        return __awaiter(this, void 0, void 0, function () {
            var eurosCountInArray, brandsAndOperatorsModel, brandCurrencyLength;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        eurosCountInArray = Enumerable.from(this.lotteryPricingModel.lotteryBrandPrices)
                            .count(function (x) { return x.currencyId != null && x.lotteryJackpotRangeId == null && x.currencyId == CurrencyEnum.Euro && x.currencyId == item.currencyId; });
                        if (!(eurosCountInArray != 1)) return [3 /*break*/, 4];
                        if (!(this.lotteryPricingModel["brand"] != null)) return [3 /*break*/, 1];
                        require("../../dialogs/delete-modal");
                        this.dialogClientService.show(DialogServiceConstants.URLs.DeleteModalConfirmation, {
                            delete: function () { return new Promise(function (resolve, reject) {
                                resolve();
                                var brandCurrencyList = _this.lotteryPricingModel["brand"]["brandCurrencies"];
                                if (brandCurrencyList.find(function (x) { return x.currencyId == item.currencyId; }) == undefined || Enumerable.from(_this.lotteryPricingModel.lotteryBrandPrices)
                                    .count(function (x) { return x.lotteryJackpotRangeId == null && x.currencyId == item.currencyId; }) > 1) {
                                    _this.deleteTicketPrice(indexPlace);
                                }
                                else {
                                    _this.notificationService.show("Validation Error!", "This currency cannot be deleted. You need to unselect the currency from the brand settings and then you can delete it from here", NotificationType.Error);
                                }
                                _this.dialogClient.hide();
                            }); }
                        });
                        return [3 /*break*/, 3];
                    case 1:
                        brandsAndOperatorsModel = {
                            lotteryId: this.item.lotteryId,
                            lotteryName: this.item.name,
                            operatorId: this.lotteryPricingModel["operatorId"],
                            currencyId: item.currencyId,
                            currencyName: item.currency.name
                        };
                        return [4 /*yield*/, this.brandLotteryOperatorDialog.createDataGridList(brandsAndOperatorsModel, 0).then(function (e) { return e; })];
                    case 2:
                        brandCurrencyLength = _a.sent();
                        if (brandCurrencyLength != 0) {
                            require("../dialogs/brandlotteryoperator-dialog-host");
                            this.dialogClient.show(DialogServiceConstants.URLs.BrandLotteryOperatorDialog, brandsAndOperatorsModel, true, true);
                        }
                        else {
                            this.deleteTicketPrice(indexPlace);
                        }
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        this.notificationService.show("Validation Error!", "You are not able to delete Euro as a Master Ticket", NotificationType.Error);
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    LotteryTickets.prototype.deleteTicketPrice = function (indexPlace) {
        var rangeList = Enumerable.from(Enumerable.from(this.item.lotteryPriceTiers).firstOrDefault().lotteryJackpotRanges)
            .select(function (x) { return x.lotteryJackpotRangeId; }).toArray();
        for (var i = 0; i <= rangeList.length; i++) {
            var getBrandPricingList = Enumerable.from(this.lotteryPricingModel.lotteryBrandPrices).where(function (x) { return x.currency != null; }).orderBy(function (x) { return x.currency.name; })
                .concat(Enumerable.from(this.lotteryPricingModel.lotteryBrandPrices).where(function (x) { return x.currency == null; }));
            var getItemToDelete = getBrandPricingList
                .where(function (x) { return x.lotteryJackpotRangeId == rangeList[i]; }).toArray()[indexPlace];
            var index = this.lotteryPricingModel.lotteryBrandPrices.indexOf(getItemToDelete);
            this.lotteryPricingModel.lotteryBrandPrices.splice(index, 1);
            this.signaler.signal("reloadPrices");
        }
    };
    LotteryTickets.prototype.currencyDropdownChanged = function ($event, index, pricingModelItem) {
        if (!$event.detail.item) {
            return;
        }
        var lotteryBrandPricingList;
        if (this.lotteryPricingModel.lotteryBrandPrices.length > 0) {
            lotteryBrandPricingList = Enumerable.from(this.lotteryPricingModel.lotteryBrandPrices)
                .where(function (x) { return x.currency != null; })
                .orderBy(function (x) { return x.currency.name; })
                .concat(Enumerable.from(this.lotteryPricingModel.lotteryBrandPrices)
                .where(function (x) { return x.currency == null; }));
        }
        var lotteryJackpotRanges = Enumerable.from(this.item.lotteryPriceTiers)
            .firstOrDefault()
            .lotteryJackpotRanges;
        var rangeList = Enumerable.from(lotteryJackpotRanges)
            .select(function (x) { return x.lotteryJackpotRangeId; })
            .toArray();
        var _loop_1 = function (i) {
            // checking the jackpot range id in lottery brand pricing table.
            var brandPricingRangeList = Enumerable.from(lotteryBrandPricingList).where(function (x) { return x.lotteryJackpotRangeId == rangeList[i]; }).toArray();
            // if has data, just replace the currency with new currency id
            if (brandPricingRangeList.length == lotteryBrandPricingList.where(function (x) { return x.lotteryJackpotRangeId == null; }).toArray().length) {
                brandPricingRangeList[index].currencyId = $event.detail.item.id;
            } // else, add new entry depends on jackpot range added in lottery price tier
            else {
                this_1.creatingCurrencyModal(rangeList[i], pricingModelItem.currency);
            }
        };
        var this_1 = this;
        for (var i = 0; i < rangeList.length; i++) {
            _loop_1(i);
        }
        // remove all border color 
        var lotteryJackpotMasterTicketRanges = Enumerable.from(lotteryBrandPricingList)
            .where(function (x) { return x.lotteryJackpotRangeId == null; })
            .toArray();
        var _loop_2 = function (i) {
            Enumerable.from(lotteryJackpotMasterTicketRanges)
                .where(function (x) { return x.currencyId == lotteryJackpotMasterTicketRanges[i].currencyId; })
                .firstOrDefault().addBorderStyle = null;
        };
        for (var i = 0; i < lotteryJackpotMasterTicketRanges.length; i++) {
            _loop_2(i);
        }
        // check for same currencies to add border color as red
        var nonUniqueCurrencies = Enumerable.from(lotteryJackpotMasterTicketRanges)
            .where(function (x) { return x.currencyId != 0; })
            .select(function (x) { return x.currencyId; }).toArray()
            .filter(function (val, indexVal, currencyArray) { return currencyArray.indexOf(val) !== indexVal; });
        var _loop_3 = function (i) {
            var findAlreadySelectedCurrency = Enumerable.from(lotteryJackpotMasterTicketRanges)
                .where(function (x) { return x.currencyId == nonUniqueCurrencies[i] && x.currencyId != 0; })
                .firstOrDefault();
            findAlreadySelectedCurrency.addBorderStyle = { 'border': '1px solid red' };
            var currencyName = Enumerable.from(this_2.currencies)
                .firstOrDefault(function (x) { return x.currencyId == findAlreadySelectedCurrency.currencyId; }).name;
            this_2.notificationService.show("Validation Error!", currencyName + " currency is already exist. You cannot select it again.", NotificationType.Error);
        };
        var this_2 = this;
        for (var i = 0; i < nonUniqueCurrencies.length; i++) {
            _loop_3(i);
        }
        this.signaler.signal("reloadPrices");
    };
    LotteryTickets.prototype.maxHundred = function (value) {
        if (value) {
            var numberValue = (Number.parseInt(value));
            if (numberValue > 100) {
                return "100";
            }
            if (numberValue < 0) {
                return "0";
            }
            return value;
        }
    };
    LotteryTickets = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService,
            I18N,
            DialogClientService,
            LotteryClientService,
            CurrencyClientService,
            BindingSignaler,
            DialogClientService,
            RequestClient, LotteryBrandsOperatorDialog])
    ], LotteryTickets);
    return LotteryTickets;
}(ChildComponent));
export { LotteryTickets };
